namespace Areas.Analysis.DownloadChart {
    "use strict";


    let startDate: string = new Date().toLocaleDateString();
    let endDate: string = new Date().toLocaleDateString();


    export function getStartDate() {
        return startDate;
    }

    export function getEndDate() {
        return endDate;
    }

    export function setLabelText(a, b) {

        var z = 1;
        return a.argumentText + " ( " + a.valueText + ")";

    }

}